// ----------------------------------------------------------------------------------------------------
// Change this single URL to switch environments for local development.
// ----------------------------------------------------------------------------------------------------

// export const BASE_API_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined)
//   || 'http://localhost:5122/api/';


export const BASE_API_URL = 'https://api-qe2p.knackgalaxy.com/api/';


//export const BASE_API_URL = 'http://20.244.27.137:5122/api/';

// ----------------------------------------------------------------------------------------------------
// Change this single value to switch app/home URL across pages.
// ----------------------------------------------------------------------------------------------------

export const BASE_APP_URL = (import.meta.env.VITE_APP_BASE_URL as string | undefined)
  || 'https://knack-dev.brainvire.net/';


//export const BASE_APP_URL = 'http://20.244.27.137:5121/';

// ----------------------------------------------------------------------------------------------------

export const appUrl = (path: string) => `${BASE_APP_URL}${path.replace(/^\//, '')}`;
export const HOME_URL = appUrl('galaxyHome');
export const LOGIN_URL = BASE_APP_URL;

export const apiUrl = (path: string) =>
  `${BASE_API_URL}${path.replace(/^\//, '')}`;

export default {
  BASE_API_URL,
  BASE_APP_URL,
  appUrl,
  HOME_URL,
  LOGIN_URL,
  apiUrl,
};

